import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';

import ModalBase from '@shared/v2/components/Modal';
import {
  AnimationGroup,
  ANIMATIONS,
} from '@shared/v2/components/Modal/animations';
import { SCREEN_SIZE } from '@shared/v2/constants';

import FocusTrap from '@/components/FocusTrap';
import ModalContext, { ModalContextProps } from './ModalContext';

const MODAL_WIDTH_MAP = {
  base: '500px',
  lg: '780px',
};

type StyledModalProps = {
  bg?: string;
  size?: 'base' | 'lg';
};

const StyledModal = styled(ModalBase)`
  max-height: 100%;
  background: ${(props: StyledModalProps) =>
    themeGet(props.bg ?? 'background.card')};
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
  overflow: hidden;

  ${SCREEN_SIZE.LG} {
    border-radius: ${themeGet('radii.md')};
    width: ${(props: StyledModalProps) =>
      MODAL_WIDTH_MAP[props.size ?? 'base']};
  }
`;
export interface ModalProps extends ModalContextProps {
  children: ReactNode;
  bg?: string;
  size?: 'base' | 'lg';
  isOpen?: boolean;
  animation?: AnimationGroup;
}

const StyledFocusTrap = styled(FocusTrap)`
  display: flex;
  flex-direction: column;
  max-height: 100%;
  ${SCREEN_SIZE.LG} {
    flex: 1;
  }
`;

const AnimatedModal = ({
  children,
  onClose,
  bg = 'background.card',
  size = 'base',
  isOpen,
  animation = ANIMATIONS.slideUpOnMobile,
}: ModalProps) => {
  return (
    <ModalContext.Provider value={{ onClose }}>
      <StyledModal
        isOpen={isOpen}
        onClose={onClose}
        size={size}
        bg={bg}
        animation={animation}
      >
        {/* @ts-ignore - bad JS type*/}
        <StyledFocusTrap>{children}</StyledFocusTrap>
      </StyledModal>
    </ModalContext.Provider>
  );
};

export default AnimatedModal;
